// Session-Cache für Meldungen je perm-id. Vermeidet erneutes Laden beim
// Zurückwechseln zwischen Standorte. Ein späterer activity/subtree-Marker
// kann hier als 'activity' hinterlegt und verglichen werden, um gezielt neu zu laden.
const cache = new Map(); // permid -> { data, activity, fetchedAt }

export const getCachedMessages = (permid) => cache.get(permid) || null;

export const setCachedMessages = (permid, data, activity = null) => {
  cache.set(permid, { data, activity, fetchedAt: Date.now() });
};

export const updateCachedMessage = (permid, patch) => {
  const e = cache.get(permid);
  if (!e || !e.data) return;
  e.data = {
    ...e.data,
    messages: (e.data.messages || []).map((m) => (String(m.id) === String(patch.id) ? { ...m, ...patch } : m)),
  };
};

export const removeCachedMessage = (permid, id) => {
  const e = cache.get(permid);
  if (!e || !e.data) return;
  e.data = {
    ...e.data,
    messages: (e.data.messages || []).filter((m) => String(m.id) !== String(id)),
    count: Math.max(0, (e.data.count || 1) - 1),
  };
};

export const invalidateMessages = (permid) => cache.delete(permid);

// Pro Meldung: Zeitstempel der zuletzt gesehenen Antwort im Verlauf.
export const getVerlaufSeen = (id) => {
  try { return localStorage.getItem(`wd_verlauf_seen_${id}`) || null; } catch { return null; }
};

export const markVerlaufSeen = (id, iso) => {
  try { if (iso) localStorage.setItem(`wd_verlauf_seen_${id}`, iso); } catch { /* ignore */ }
};
